export class Participant {
    participant_event_id: number;
    participant_race_number: string;
    participant_column1: string;
    participant_column2: string;
    participant_column3: string;
    participant_column4: string;
    participant_column5: string;
    participant_column6: string;
    participant_column7: string;
    participant_column8: string;
    participant_column9: string;
    participant_column10: string;
}